import HiggsPromise from '../../utils/higgsPromise';

//  财务画像-财务风险分析-获取风险分析数据
export function queryRiskAnalysis(data) {
    return HiggsPromise({
        url: '/finance/portrait/risk/analysis',
        data: data
    });
}

// 杜邦分析
export function dupontAnalysis(data) {
    return HiggsPromise({
        url: '/finance/portrait/risk/dupont/analysis',
        data: data
    });
}

// 隐患列表
export function tipList(data) {
    return HiggsPromise({
        url: '/finance/portrait/risk/tips/list',
        data: data
    });
}

// 隐患详情
export function tipDetail(data) {
    return HiggsPromise({
        url: '/finance/portrait/fraud/tips/detail',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/financialPicture/riskAnalysis.js